import {types} from '../../types';

const setGetSupportListAction = (payload) => {
    return {
        type: types.support.SET_SUPPORT_LIST_MOBILE,
        payload,
      }
}

const setGetSupportViewAction = (payload) => {
  return {
    type: types.support.SET_SUPPORT_VIEW_MOBILE,
    payload
  }
}

export {
  setGetSupportListAction as SetGetSupportListAction,
  setGetSupportViewAction as SetGetSupportViewAction
}
